



















































































































import { Component, Vue } from 'vue-property-decorator'
import { CompanyAPI, PipelineConnectionAPI } from '@/api/backend-client'
import { PipelineConnection } from '@/api/model/pipeline-connection'
import { cloneDeep } from 'lodash'
import EditOutgoingPipelineConnection from '@/views/Company/Settings/Pipelines/ConnectionsOutgoing/EditOutgoingPipelineConnection.vue'
import ModalAddConnection from '@/views/Company/Settings/Pipelines/ConnectionsOutgoing/ModalAddConnection.vue'
import IconExchange from '@/components/icons/IconExchange.vue'
import IconArrowDoubleRight from '@/components/icons/IconArrowDoubleRight.vue'
import LoaderBalls from '@/components/LoaderBalls.vue'
import ListContainer from '@/components/ui/list/ListContainer.vue'
import ListItem from '@/components/ui/list/list-item/ListItem.vue'
import ListItemClickIndicator from '@/components/ui/list/list-item/ListItemClickIndicator.vue'
import ListItemLabel from '@/components/ui/list/list-item/ListItemLabel.vue'
import ListItemStatus from '@/components/ui/list/list-item/ListItemStatus.vue'
import ListItemAction from '@/components/ui/list/list-item/ListItemAction.vue'
import KvButton from '@/components/input/KvButton.vue'

@Component({
    components: {
        KvButton,
        ListItemAction,
        ListItemStatus,
        ListItemLabel,
        ListItemClickIndicator,
        ListItem,
        ListContainer,
        LoaderBalls,
        IconArrowDoubleRight,
        IconExchange,
        EditOutgoingPipelineConnection,
        ModalAddConnection,
    },
})
export default class ConnectionsOutgoing extends Vue {
    pipelineConnections: PipelineConnection[] = []
    editingId: string = null
    loading: boolean = false
    updating: boolean = false
    deleting: boolean = false

    async mounted(): Promise<void> {
        await this.loadContent()
    }

    async loadContent(): Promise<void> {
        this.loading = true
        this.pipelineConnections = await CompanyAPI.getOutgoingConnections()
        this.loading = false
    }

    async addConnection(connection: PipelineConnection): Promise<void> {
        this.loading = true
        await PipelineConnectionAPI.create(cloneDeep(connection))
        this.pipelineConnections.push(connection)
        this.loading = false
    }

    async updateConnection(connection: PipelineConnection): Promise<void> {
        this.updating = true
        const index = this.pipelineConnections.findIndex(v => v.id === connection.id)
        await PipelineConnectionAPI.update(connection.id, connection)
        this.pipelineConnections[index] = connection
        this.updating = false
        this.editingId = null
    }

    async deleteConnection(connection: PipelineConnection): Promise<void> {
        this.deleting = true
        const index = this.pipelineConnections.findIndex(v => v.id === connection.id)
        await PipelineConnectionAPI.delete(connection.id)
        this.pipelineConnections.splice(index, 1)
        this.deleting = false
        this.editingId = null
    }

    getConnection(id: string) {
        return this.pipelineConnections.find(pipelineConnection => pipelineConnection.id === id)
    }

    getConnectionLabel(connection: PipelineConnection): string {
        return connection.pipeline?.name || '-'
    }

    getConnectionStatusIcon(connection: PipelineConnection): string {
        return 'icon-dot'
    }

    getConnectionStatusLabel(connection: PipelineConnection): string {
        if (connection.sourceEnabled && connection.targetEnabled) {
            return this.$t('company_settings.pipelineConnections.status.active').toString()
        }

        if (!connection.sourceEnabled && !connection.targetEnabled) {
            return this.$t('company_settings.pipelineConnections.status.inactive').toString()
        }

        return this.$t('company_settings.pipelineConnections.status.interrupted').toString()
    }

    getConnectionStatusColor(connection: PipelineConnection): string {
        if (connection.sourceEnabled && connection.targetEnabled) {
            return 'green'
        }

        if (!connection.sourceEnabled && !connection.targetEnabled) {
            return 'red'
        }

        return 'orange'
    }

    get connectionsPerCompany(): Array<{ name: string, pipelineConnectionIds: string[] }> {
        const results = new Map<string, string[]>()

        this.pipelineConnections.forEach(entry => {
            const name = entry.targetCompany.name

            if (!results.has(name)) {
                results.set(name, [])
            }

            results.get(name).push(entry.id)
        })

        return Array
            .from(results.entries())
            .map(([name, pipelineConnectionIds]) => ({ name, pipelineConnectionIds }))
            .sort((a, b) => a.name.localeCompare(b.name))
    }
}
